// Convert between "GWAII HAANAS" and "gwaii-haanas"
export const workareaURLStyle = workarea =>
  workarea.toLowerCase().replace(" ", "-");
export const workareaAPIStyle = workarea =>
  workarea.toUpperCase().replace("-", " ");
